import * as angular from 'angular';

export interface StorageFilter {
    (input: string): string;
}

function storageQuantityUnitFilter(
    $translate: ng.translate.ITranslateService
): StorageFilter {
    return function (input: string): string {
        return $translate.instant(input).replace('&#179;', '³');
    };
}

angular
    .module('app')
    .filter('pkpStorageQuantityTranslate', storageQuantityUnitFilter);
